import React, { useState } from "react";
import "./contact.css";
import Header from "../components/layout/Header";
import Footer from "./Footer";

const BASE_URL = "https://api.suvidhaeldercare.com/";


export default function Contact() {
  const [form, setForm]       = useState({ name:"", phone:"", email:"", subject:"", message:"" });
  const [submitted, setSubmitted] = useState(false);
  const [submitType, setSubmitType] = useState("message"); // "message" | "call_request"
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  const handleChange = (e) =>
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (type) => {
    if (!form.name || !form.phone || !form.message)
      return setError("Please fill in Name, Phone and Message fields.");
    if (!/^[0-9]{10}$/.test(form.phone))
      return setError("Please enter a valid 10-digit phone number.");

    setLoading(true); setError(""); setSubmitType(type);
    try {
      const res  = await fetch(`${BASE_URL}/api/contact`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ ...form, type }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Submission failed");
      setSubmitted(true);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsApp = () => {
    const msg = `Hello, I am ${form.name || "a visitor"} and I want to know more about Suvidha Elder Care services.`;
    window.open(`https://wa.me/919390683569?text=${encodeURIComponent(msg)}`, "_blank");
  };

  const reset = () => {
    setSubmitted(false);
    setForm({ name:"", phone:"", email:"", subject:"", message:"" });
    setError("");
  };

  return (
    <>
      <Header />
      <div className="contact-page">

        {/* HERO */}
        <section
          className="contact-hero"
          role="img"
          aria-label="Get in touch. Let's make care easier, together. Tell us what your parents need — our care team will help you find the right support, simply and personally."
        >
          {/* Desktop / tablet: full designed banner, text baked into the image */}
          <div className="contact-hero-full" />

          {/* Mobile: the same image, split into a legible text crop
              stacked above a photo crop — avoids shrinking the baked-in
              text down to unreadable sizes on narrow screens. */}
          <div className="contact-hero-mobile">
            <div className="chm-text" />
            <div className="chm-photo" />
          </div>
        </section>

        <div className="contact-body">

          {/* INFO CARDS */}
          <section className="contact-cards">
            <div className="contact-card">
              <div className="contact-card-icon">📍</div>
              <h3>Visit Us</h3>
              <p>Suvidha Elder Care<br />Hyderabad, Telangana<br />India — 500001</p>
            </div>
            <div className="contact-card">
              <div className="contact-card-icon">📞</div>
              <h3>Call Us</h3>
              <p>+91 93906 83569<br />Mon – Sat: 9 AM – 7 PM<br />Sunday: 10 AM – 4 PM</p>
            </div>
            <div className="contact-card">
              <div className="contact-card-icon">✉️</div>
              <h3>Email Us</h3>
              <p>support@suvidhacare.in<br />info@suvidhacare.in<br />Response within 24 hrs</p>
            </div>
            <div className="contact-card contact-card-whatsapp" onClick={handleWhatsApp}>
              <div className="contact-card-icon">💬</div>
              <h3>WhatsApp</h3>
              <p>Chat with us instantly<br />+91 93906 83569<br /><span className="contact-link">Open WhatsApp →</span></p>
            </div>
          </section>

          {/* FORM + MAP */}
          <section className="contact-main">

            {/* FORM */}
            <div className="contact-form-wrap">
              <h2 className="contact-form-title">Send us a message</h2>
              <p className="contact-form-sub">Fill the form below and we'll get back to you within 24 hours.</p>

              {submitted ? (
                <div className="contact-success">
                  <div className="contact-success-icon">
                    {submitType === "call_request" ? "📞" : "✅"}
                  </div>
                  <h3>
                    {submitType === "call_request" ? "Call Request Received!" : "Message Sent!"}
                  </h3>
                  <p>
                    Thank you <strong>{form.name}</strong>!{" "}
                    {submitType === "call_request"
                      ? <>Our team will call you shortly on <strong>{form.phone}</strong>. Please keep your phone handy.</>
                      : <>We've received your message and will contact you within 24 hours on <strong>{form.phone}</strong>.</>
                    }
                  </p>
                  <button className="contact-btn" onClick={reset}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <>
                  {error && (
                    <div style={{
                      background:"#FEF2F2", border:"1px solid #FECACA",
                      borderRadius:10, padding:"12px 16px",
                      color:"#DC2626", fontSize:14, marginBottom:16
                    }}>⚠️ {error}</div>
                  )}

                  <form className="contact-form" onSubmit={e => { e.preventDefault(); submit("message"); }}>
                    <div className="contact-row">
                      <div className="contact-field">
                        <label>Full Name *</label>
                        <input name="name" value={form.name} onChange={handleChange}
                          placeholder="Your full name" required />
                      </div>
                      <div className="contact-field">
                        <label>Phone Number *</label>
                        <input name="phone" value={form.phone} onChange={handleChange}
                          placeholder="10-digit phone" maxLength={10} inputMode="numeric"
                          onInput={e => e.target.value = e.target.value.replace(/\D/g,"")} />
                      </div>
                    </div>

                    <div className="contact-row">
                      <div className="contact-field">
                        <label>Email Address</label>
                        <input name="email" value={form.email} onChange={handleChange}
                          placeholder="your@email.com" type="email" />
                      </div>
                      <div className="contact-field">
                        <label>Subject</label>
                        <select name="subject" value={form.subject} onChange={handleChange}>
                          <option value="">Select a subject</option>
                          <option value="General Enquiry">General Enquiry</option>
                          <option value="Plans & Pricing">Plans &amp; Pricing</option>
                          <option value="Home Care Services">Home Care Services</option>
                          <option value="Medical Assistance">Medical Assistance</option>
                          <option value="Emergency Support">Emergency Support</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    <div className="contact-field">
                      <label>Message *</label>
                      <textarea name="message" value={form.message} onChange={handleChange}
                        placeholder="Tell us how we can help you and your loved ones..."
                        rows={5} required />
                    </div>

                    {/* Action buttons */}
                    <div className="contact-form-actions">
                      {/* Send Message */}
                      <button className="contact-btn" type="submit" disabled={loading}>
                        {loading && submitType === "message" ? "Sending..." : "✉️ Send Message"}
                      </button>

                      {/* Request a Call */}
                      <button
                        className="contact-btn"
                        type="button"
                        disabled={loading}
                        onClick={() => submit("call_request")}
                        style={{ background:"#16A34A", borderColor:"#16A34A" }}
                      >
                        {loading && submitType === "call_request" ? "Requesting..." : "📞 Request a Call"}
                      </button>

                      {/* WhatsApp */}
                      <button className="contact-btn-wa" type="button" onClick={handleWhatsApp}>
                        💬 WhatsApp Us
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>

            {/* RIGHT SIDE */}
            <div className="contact-side">
              <div className="contact-map">
                <iframe
                  title="Suvidha Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.3176532154!2d78.24323001640624!3d17.412281898001296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1709800000000!5m2!1sen!2sin"
                  width="100%" height="260"
                  style={{ border:0, borderRadius:16 }}
                  allowFullScreen="" loading="lazy"
                />
              </div>

              <div className="contact-hours">
                <h3>🕐 Working Hours</h3>
                <ul>
                  <li><span>Monday – Friday</span><strong>9:00 AM – 7:00 PM</strong></li>
                  <li><span>Saturday</span><strong>9:00 AM – 5:00 PM</strong></li>
                  <li><span>Sunday</span><strong>10:00 AM – 4:00 PM</strong></li>
                  <li className="contact-hours-emergency">
                    <span>Emergency</span><strong>24 / 7</strong>
                  </li>
                </ul>
              </div>

              <div className="contact-social">
                <h3>Follow Us</h3>
                <div className="contact-social-links">
                  <a href="#" className="csocial-btn">📘 Facebook</a>
                  <a href="#" className="csocial-btn">📸 Instagram</a>
                  <a href="#" className="csocial-btn">▶️ YouTube</a>
                </div>
              </div>
            </div>

          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}